import React from 'react';
import HeaderSection from './HeaderSection';
import MainContentIllustrationSection from './MainContentIllustrationSection';

const Index = () => {
  return (
    <div className="flex flex-col w-full my-20">
      <div className="flex-grow">
        <HeaderSection />
      </div>
      <div className="flex-grow">
        <MainContentIllustrationSection />
      </div>
    </div>
  );
};

export default Index;

